<template>
  <div>
    <b-modal
      id="modal-addprod"
      ref="addprod"
      hide-footer
      centered
      title="Ajouter un produit"
    >
      <div class="pl-lg-4">
        <div class="row">
          <div class="col-12">
            <div>
              <center>
                <b-form-input
                  type="text"
                  placeholder="Nom du produit"
                  v-model="attributeName"
                ></b-form-input>
              </center>
            </div>
          </div>
        </div>
      </div>

      <hr class="my-4" />
      <center>
        <b-btn
          type="submit"
          style="background-color: #c2b59b; color: #fff"
          @click="addAttribute"
          >Ajouter</b-btn
        >
      </center>
    </b-modal>
    <GStockLoader :loading="loading" />
  </div>
</template>
<script>
import GStockLoader from "@/components/Loader";
import { post } from "@/mixins/api";
export default {
  name: "addattribute",
  components: {
    GStockLoader,
  },
  data() {
    return {
      loading: false,
      modalupd: false,
      attributeName: "",
    };
  },
  methods: {
    setId() {
      this.$refs.addprod.show();
    },
    addAttribute() {
      if (this.attributeName.length == 0) return;
      this.loading = true;
      const model = {
        name: this.attributeName,
        attributes: '',
      };
      post("stp", model)
        .then((resp) => {
          this.$emit("updated");
          this.$refs.addprod.hide();
        })
        .finally(() => {
          this.loading = false;
        });

      this.modalupd = true;
    },
  },
  mounted() {},
};
</script>
                        